import type { ReactNode } from 'react';
import { BottomTabBar } from './BottomTabBar';
import { TopNav } from './TopNav';

interface PageLayoutProps {
  children: ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  className?: string;
}

const maxWidthClasses = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  full: 'max-w-full',
};

export function PageLayout({
  children,
  maxWidth = 'full',
  className = ''
}: PageLayoutProps): React.JSX.Element {
  return (
    <div className="min-h-screen">
      <TopNav />

      {/* Main Content - below top nav, with bottom padding for mobile tab bar */}
      <main className={`min-h-[calc(100vh-4rem)] pb-20 md:pb-8 ${maxWidthClasses[maxWidth]} mx-auto px-4 sm:px-6 lg:px-8 py-8 ${className}`}>
        {children}
      </main>

      {/* Bottom Tab Bar - Mobile only */}
      <BottomTabBar />
    </div>
  );
}
